export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/helloradius_",
  facebook: "https://www.facebook.com/helloradius/",
  twitter: "https://www.twitter.com/helloradius_",
  linkedIn: "https://www.linkedin.com/company/hello-radius/",
};
